import React, { useEffect, useRef } from 'react';
import { motion, useInView, animate } from 'framer-motion';
interface CounterProps {
  from: number;
  to: number;
  duration: number;
  prefix?: string;
  suffix?: string;
}
function Counter({
  from,
  to,
  duration,
  prefix = '',
  suffix = ''
}: CounterProps) {
  const nodeRef = useRef<HTMLSpanElement>(null);
  const inView = useInView(nodeRef, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (inView) {
      const controls = animate(from, to, {
        duration,
        ease: 'easeOut',
        onUpdate(value) {
          if (nodeRef.current) {
            nodeRef.current.textContent = `${prefix}${Math.round(value)}${suffix}`;
          }
        }
      });
      return () => controls.stop();
    }
  }, [from, to, duration, prefix, suffix, inView]);
  return <span ref={nodeRef} data-id="element-319">
      {prefix}
      {from}
      {suffix}
    </span>;
}
export function Stats() {
  return <section className="py-20 md:py-28 relative bg-white border-y border-slate-200" data-id="element-320">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-321">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-0" data-id="element-322">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-center" data-id="element-323">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-324">
              <Counter from={0} to={85} duration={2} suffix="%" data-id="element-325" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-326">
              Less CRM busywork
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-327">
              vs. manual note-taking
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.08
        }} className="text-center md:border-x md:border-slate-200" data-id="element-328">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-329">
              <Counter from={0} to={3} duration={1.5} suffix="x" data-id="element-330" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-331">
              More complete deal records
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-332">
              compared to manual entry
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.16
        }} className="text-center" data-id="element-333">
            <div className="text-6xl md:text-7xl font-light text-slate-900 mb-4 tracking-tight" data-id="element-334">
              <Counter from={0} to={2} duration={1.5} prefix="<" suffix=" min" data-id="element-335" />
            </div>
            <p className="text-sm text-slate-600 font-medium uppercase tracking-wider mb-1" data-id="element-336">
              Call to HubSpot sync
            </p>
            <span className="block text-xs text-slate-500 font-normal normal-case tracking-normal" data-id="element-337">
              from call end to synced data
            </span>
          </motion.div>
        </div>
      </div>
    </section>;
}